module.exports = __webpack_public_path__ + "img/measurement_info_back_shoulder_right_animated.c0800c6b.gif";